module.exports = {
  ColorsData: () => {
    return {
      "avatr7" : 
      [
        // {
        //   "id": "skylight_silk",
        //   "name" : "Skylight Silk",
        //   "icon": require('../assets/colors/avatr7/skylight-silk.png'),
        //   "active" : true,
        //   "interactable" : true
        // },
        {
          "id": "mineral_rock_black",
          "name" : "Black",//"Mineral Rock Black",
          "icon": require('../assets/colors/avatr7/mineral-rock-black.png'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "andes_gray",
          "name" : "Gray",//"Andes Gray",
          "icon": require('../assets/colors/avatr7/andes-gray.png'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "cotton_white",
          "name" : "White",//"Cotton White",
          "icon": require('../assets/colors/avatr7/cotton-white.png'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "damson_metallic",
          "name" : "Purple",//"Damson Metallic",
          "icon": require('../assets/colors/avatr7/damson-metallic.png'),
          "active" : true,
          "interactable" : true
        },
      ],
      "avatr11" : 
      [
        {
          "id": "glossy_white",
          "name" : "Glossy White",
          "icon": require('../assets/colors/avatr11/glossy-white.png'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "glossy_gray",
          "name" : "Glossy Gray",
          "icon": require('../assets/colors/avatr11/glossy-gray.png'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "glossy_black",
          "name" : "Glossy Black",
          "icon": require('../assets/colors/avatr11/glossy-black.png'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "liquid_caramel",
          "name" : "Liquid Caramel",
          "icon": require('../assets/colors/avatr11/liquid-caramel.png'),
          "active" : true,
          "interactable" : true
        },
        // "Matt White" no aparece en avatr.com/en/11: no hay ícono oficial (usa uno provisional).
        {
          "id": "matt_white",
          "name" : "Matt White",
          "icon": require('../assets/colors/avatr11/glossy-white.png'),
          "active" : true,
          "interactable" : true
        },
        {
          "id": "matt_gray",
          "name" : "Matt Gray",
          "icon": require('../assets/colors/avatr11/matt-gray.png'),
          "active" : true,
          "interactable" : true
        },
        // Dual-Tone (gris/negro) sí aparece en avatr.com/en/11. Para usarlo, descomentar y
        // ajustar el "id" al nombre del color configurado en PlayCanvas.
        // {
        //   "id": "dual_tone_gray_black",
        //   "name" : "Dual-Tone",
        //   "icon": require('../assets/colors/avatr11/dual-tone-gray-black.png'),
        //   "active" : true,
        //   "interactable" : true
        // },
      ],

    }
  }
}